import React from 'react';
import { ProductButton, ProductButtonsContainer, ProductButtonWrapper } from '../GameContext.style';
import { ButtonShapes } from '@mlb/react-patterns/v4/components/Button/button.types';
import { getProductButtons } from './productButtonHelper';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import BuyTicketsButtonDataContainer from '../../TicketsButton/BuyTicketsButtonDataContainer';
export const ProductButtons = () => {
    const translate = useTranslate();
    const buttons = getProductButtons();

    if (!buttons) {
        return null;
    }

    return (
        <ProductButtonsContainer>
            { buttons.map((button) => {
                const { id, labelFallback, labelKey, url, handlers } = button;
                const buttonLabel = translate(labelKey, labelFallback);
                return (
                    id === 'tickets'
                        ? <BuyTicketsButtonDataContainer key={id} />
                        : <ProductButtonWrapper key={id}>
                            <ProductButton
                                shape={ButtonShapes.PILL}
                                label={buttonLabel}
                                url={url}
                                handlers={handlers}
                                className={'gamedayButton'}
                            />
                        </ProductButtonWrapper>
                );
            })}
        </ProductButtonsContainer>
    );
};
